import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qualifications-modal',
  templateUrl: './qualifications-modal.component.html',
  styleUrls: ['./qualifications-modal.component.css']
})
export class QualificationsModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA)
    public data: any) { }


}
